import merge from 'lodash/merge';

export const mergeStrict = <T>(...source: ReadonlyArray<T>): T => {
  return merge({} as T, ...source);
};
